import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

const links = [
  { to: '/', labelKey: 'nav.home' },
  { to: '/music', labelKey: 'nav.music' },
  { to: '/photos', labelKey: 'nav.photos' },
  { to: '/videos', labelKey: 'nav.videos' },
  { to: '/fanwall', labelKey: 'nav.fanwall' },
  { to: '/merch', labelKey: 'nav.merch' },
  { to: '/contact', labelKey: 'nav.contact' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <nav className="site-nav">
      {links.map(({ to, labelKey }) => {
        const isActive = location.pathname === to || (to !== '/' && location.pathname.startsWith(to));
        return (
          <Link
            key={to}
            to={to}
            className={`site-nav__link ${isActive ? 'site-nav__link--active' : ''}`}
          >
            {t(labelKey)}
          </Link>
        );
      })}
    </nav>
  );
}
